module.exports = __webpack_public_path__ + "static/img/update_page.2a7cdee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/survey/update_page.png
// module id = jboD
// module chunks = 1